export default "__VITE_ASSET__Ug3OSJTV__"